import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { pageRoutes } from "../utils";

export default function MemberPaymentSuccess() {
  return (
    <div className="font-sans-clean min-h-screen bg-[#FDF8F3]">
      <section className="relative py-20 sm:py-24 overflow-hidden bg-[#722F37]">
        <div className="absolute inset-0 opacity-20 pointer-events-none ethiopian-cross" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6">
          <div className="flex items-start gap-4 text-white">
            <CheckCircle2 className="mt-1 h-7 w-7 flex-shrink-0 text-[#E7D6A8]" />
            <div>
              <h1 className="font-serif-elegant text-4xl sm:text-5xl font-bold mb-4">
                Membership payment submitted
              </h1>
              <p className="text-lg text-white/85 leading-relaxed">
                Thank you. Your membership payment was submitted securely through
                Stripe. You will receive a confirmation receipt by email after
                payment is confirmed.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-3xl border border-[#C9A227]/10 p-8 shadow-sm">
          <p className="text-gray-700 leading-relaxed">
            The parish system confirms paid membership only after Stripe sends a
            verified payment confirmation to the backend. This page does not mark
            your membership as paid.
          </p>
          <Link
            to={pageRoutes.MemberDashboardMembership}
            className="mt-6 inline-flex rounded-xl bg-[#722F37] px-5 py-3 text-sm font-semibold text-white hover:bg-[#5A252C]"
          >
            View membership status
          </Link>
        </div>
      </div>
    </div>
  );
}
